import { AtButton, ArrowTr } from '../../atoms'
import { AtButtonDimensions, AtButtonTypes } from '../../types'
import { Image, MlImages } from '../../molecules'

export interface OrZoSectionProps {
  dataTestId?: string
  title: string
  subTitle: string
  label: string
  logo: Image
  backgroundImage: Image
  onClick?: () => void
  onTrackClick?: () => void
}

export const OrZoSection = ({
  title,
  subTitle,
  label,
  logo: { alt, src, width, height },
  backgroundImage,
  onClick,
  onTrackClick,
  dataTestId = 'or-zo-section',
}: OrZoSectionProps) => {
  return (
    // VQA REF: studio-or-zo-section , studio-or-zo-section-at-button, studio-or-zo-section-ml-image
    // TODO: remove when QA has completed their pass

    <section data-testid={dataTestId} className="mx-auto max-w-[1440px]">
      <div className="flex flex-col lg:flex-row">
        <div className="lg:w-6/12 lg:pr-14 lg:pl-[11%] max-w-[750px]">
          <div className="mb-6">
            <img alt={alt} src={src} width={width} height={height} className="w-32 lg:w-[12rem]" />
          </div>
          <div className="mb-4">
            <h1 className="font-zo text-24 lg:text-40 text-zocolors-primary leading-1.5">{title}</h1>
          </div>
          <div className="mb-10">
            <h2 className="text-zocolors-secondary text-14 lg:text-16 lg:leading-1.5">{subTitle}</h2>
          </div>
          <div className="mb-10 lg:mb-0">
            <AtButton
              title={label}
              type={AtButtonTypes.SECONDARY}
              size={AtButtonDimensions.LARGE}
              IconRightRef={ArrowTr}
              className="w-64"
              align="center"
              onClick={onClick}
              onTrackClick={onTrackClick}
            />
          </div>
        </div>
        <div className="max-w-[750px]">
          <MlImages unsetMaxDimensions images={[backgroundImage]} aspectRatio="16:9" />
        </div>
      </div>
    </section>
  )
}
